import { render, staticRenderFns } from "./bo-svg.vue?vue&type=template&id=ad063482"
import script from "./bo-svg.vue?vue&type=script&lang=js"
export * from "./bo-svg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports